
import { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { NavLinks } from './navbar/NavLinks';
import { AuthButtons } from './navbar/AuthButtons';
import { MobileMenu } from './navbar/MobileMenu';
import { Logo } from './navbar/Logo';

export const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'py-3 bg-white shadow-md dark:bg-[#222632]' : 'py-5 bg-white dark:bg-[#222632]'
      }`}
    >
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between">
          <div onClick={() => setMobileMenuOpen(false)}>
            <Logo />
          </div>

          {/* Desktop Navigation */}
          <NavLinks />

          {/* Auth Buttons */}
          <AuthButtons />

          {/* Mobile Menu Button */}
          <button 
            className="md:hidden flex items-center text-tranquil-neutral dark:text-white"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label={mobileMenuOpen ? 'Close menu' : 'Open menu'}
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <MobileMenu isOpen={mobileMenuOpen} onClose={() => setMobileMenuOpen(false)} />
    </header>
  );
};

export default Navbar;
